export * from './async_user';

export const USERPROFILE_INVALIDATE = 'USERPROFILE_INVALIDATE';

export function invalidateUserProfile(){
  return {
    type: USERPROFILE_INVALIDATE
  }
}
